import React, { useState } from 'react';
import { AlertOctagon, ChevronDown, ChevronUp } from 'lucide-react';

export const RiskBox = ({ collapsible = false }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="rounded-xl border border-amber-500/30 bg-amber-950/15 backdrop-blur-md overflow-hidden transition-all duration-200">
      {/* Risk Box Header */}
      <div
        onClick={() => collapsible && setIsOpen(!isOpen)}
        className={`p-3.5 flex items-center justify-between ${
          collapsible ? 'cursor-pointer hover:bg-amber-500/5 select-none' : ''
        }`}
      >
        <div className="flex items-center space-x-2.5 text-amber-400">
          <AlertOctagon className="w-4 h-4 flex-shrink-0" />
          <h4 className="text-xs font-mono font-bold tracking-wider uppercase">
            Regulatory & Margin Risk Disclosure
          </h4>
        </div>
        {collapsible && (
          <button
            type="button"
            className="text-amber-400/80 hover:text-amber-300 cursor-pointer"
            aria-label="Toggle risk disclosure"
          >
            {isOpen ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
          </button>
        )}
      </div>

      {/* Content (always shown on desktop, collapsible on mobile) */}
      {(!collapsible || isOpen) && (
        <div className="px-3.5 pb-3.5 pt-0 border-t border-amber-500/15 text-[11px] text-amber-200/80 font-mono space-y-2 leading-relaxed">
          <p>
            <strong className="text-amber-300 font-semibold">// 01. CAPITAL EXPOSURE:</strong> High-frequency algorithmic trading and leveraged derivatives carry significant risk of capital loss. Past algorithmic performance does not predict future returns.
          </p>
          <p>
            <strong className="text-amber-300 font-semibold">// 02. PROBABILISTIC MODELS:</strong> AI Copilot analysis and Confluence Scanner signals are automated mathematical heuristics provided for analytical purposes, not certified financial advice.
          </p>
          <p>
            <strong className="text-amber-300 font-semibold">// 03. SYSTEM ACCESS POLICY:</strong> Automated credential scanning or penetration testing is prohibited and triggers immediate IP quarantine and telemetry logging.
          </p>
          <div className="pt-1 text-[10px] text-amber-400/60 uppercase tracking-widest border-t border-amber-500/10">
            FINANCIAL REGULATION COMPLIANT // MARGIN LEVEL & ORDER GOVERNANCE
          </div>
        </div>
      )}
    </div>
  );
};

export default RiskBox;
